if(!customElements.get('custom-contact-form')){

  class CustomContactForm extends HTMLElement {
    constructor(){
      super();
      this.init();
    }

    init(){
      // All wrappers that control the floating labels
      this.inputWrappers = this.querySelectorAll('.input-wrapper');

      // All form elements we care about
      this.inputs = this.querySelectorAll('input, textarea, select');

      this.inputs.forEach((item)=>{
        item.addEventListener('focus', this.focusOnInput.bind(this));
        item.addEventListener('focusout', this.focusOutOnInput.bind(this));
        item.addEventListener('input', this.handleInput.bind(this));
        item.addEventListener('change', this.handleInput.bind(this)); // for selects
      });

      // Clicking label focuses the input/select
      this.labels = this.querySelectorAll('.input-wrapper label');
      this.labels.forEach((label)=>{
        label.addEventListener('click', (e)=>{
          const wrapper = e.currentTarget.closest('.input-wrapper');
          if(!wrapper) return;

          const inputs = wrapper.querySelectorAll('input, textarea, select');
          inputs.forEach((input)=>{
            input.focus();
          });
        });
      });

      // Initialize state on load so labels are in the right place
      this.inputWrappers.forEach((wrapper)=>{
        const input = wrapper.querySelector('input, textarea, select');
        if(!input) return;

        const value = (input.value || '').trim();
        wrapper.setAttribute('data-selected', value ? 'true' : 'false');
      });
    }

    handleInput(e){
      const wrapper = e.currentTarget.closest('.input-wrapper');
      if(!wrapper) return;

      const value = (e.currentTarget.value || '').trim();
      wrapper.setAttribute('data-selected', value ? 'true' : 'false');
    }

    focusOnInput(e){
      const wrapper = e.currentTarget.closest('.input-wrapper');
      if(!wrapper) return;
      wrapper.setAttribute('data-selected', 'true');
    }

    focusOutOnInput(){
      this.inputWrappers.forEach((wrapper)=>{
        const input = wrapper.querySelector('input, textarea, select');
        if(!input) return;

        const value = (input.value || '').trim();
        wrapper.setAttribute('data-selected', value ? 'true' : 'false');
      });
    }
  }

  customElements.define('custom-contact-form', CustomContactForm);

}